import { Box, Typography } from '@mui/material'
import StatusBar from '../../generic/StatusBar'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { apiGet } from '../../generic/Api_Functions'
import { StorageRounded } from '@mui/icons-material'
import { systemValueLabel } from '../../generic/systemValues/systemValueLabel'

const FabricationOrderPartProgressDialog = (props) => {
  const { t_ } = useSmartTranslation()
  const { fabricationOrder, open, setOpen } = props

  const jobProgressFetch = async (pagination) => {
    const jobs = await apiGet('fabricationOrderJobProgress/' + fabricationOrder.id, pagination)
    return jobs
  }

  const partProgressFetch = async () => {
    return await apiGet('fabricationOrderPartProgress/' + fabricationOrder.id)
  }

  return (
    <SmartDialog
      title={{ icon: <StorageRounded color='primary' />, render: <Typography variant='h5' color='primary' sx={{ marginLeft: '0.3em' }}>{fabricationOrder?.fabricationOrder}</Typography> }}
      closeCallback={() => setOpen(false)}
      accept={false}
      cancel={false}
      close
      renderComponent={
        <>
          <StatusBar
            dataFetch={partProgressFetch}
            sections={[
              { code: 'FINISHED', color: '#10b981' },
              { code: 'WORKING', color: '#3b82f6' },
              { code: 'RAW', color: '#6b7280' },
              { code: 'SCRAP', color: '#ef4444' }
            ]}
          />
          <Box sx={{ marginLeft: 0, textAlign: 'left', width: '100%', marginBottom: 3 }}>
            <Typography variant='p' color='primary' sx={{ marginLeft: '0em' }}>
              {t_('Total parts:')}
            </Typography>
            <Typography variant='p' sx={{ marginLeft: '0.3em' }}>
              {fabricationOrder?.totalQuantity}
            </Typography>
          </Box>
          <SmartMateriaUITable
            columns={[{
              name: t_('Job'),
              field: 'name',
              edit: false
            }, {
              name: t_('Status'),
              field: 'status',
              edit: false,
              render: (row) => systemValueLabel(t_, 'DeviceFabricationOrderStatusTypeEnum', row.status)
            }, {
              name: t_('Pending'),
              field: 'quantity',
              edit: false,
              render: (row) => `${row.quantity ?? 0}`
            }, {
              name: t_('Reported'),
              field: 'reported',
              edit: false,
              render: (row) => `${row.reportedOk ?? 0} - OK / ${row.reportedNok ?? 0} - NOK`
            }]}
            dataFetch={jobProgressFetch}
            dense
            toolbarDisplay='none'
            pageable
          />
        </>
            }
      setOpen={open}
    />
  )
}

export default FabricationOrderPartProgressDialog
